module.exports = __webpack_public_path__ + "static/media/Plus.1b8b8310.svg";